import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { JobStatus } from '@y42/json-schema';
import { JobStatusToIcon, noJobIcon, StatusName } from '../../../state';

@UntilDestroy()
@Component({
  selector: 'y42-job-status-cell-renderer',
  templateUrl: './job-status-cell-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobStatusCellRendererComponent extends BaseCellRendererComponent<JobStatus> {
  readonly defaultStatusData = {
    label: StatusName.NoJob,
    icon: noJobIcon,
  };
  readonly JobStatus = JobStatus;
  readonly JobStatusToIcon = JobStatusToIcon;
  readonly StatusName = StatusName;

  state = connectState(this, {
    jobStatus: this.value$,
  });
}
